export type Loading = {
  status: 'start' | 'params' | 'hrx' | 'variant' | 'store-settings' | 'app-layout' | 'model' | 'end' | 'error';
  text: string;
};

export const loading: Loading = {
  status: 'start',
  text: '',
};
